module.exports = __webpack_public_path__ + "img/emoji_56.4e635df6.png";